import React, { useMemo } from "react";

// Material UI imports
import { DataGrid } from "@mui/x-data-grid";
import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomPagination from "./common/Pagination";
import { CustomToolbar } from "./common/CustomToolbar";
import { reorderColumnsWithFixedEnd } from "../../utils/download";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& ::-webkit-scrollbar": {
    "border-top": "1px solid #e9e9ec",
    height: "7px",
    width: "7px",
  },
  "& ::-webkit-scrollbar-thumb:horizontal": {
    "border-radius": "15px",
    "background-color": "#6d6d6dc9",
  },
  "& ::-webkit-scrollbar-thumb:vertical": {
    "border-radius": "15px",
    "background-color": "#6d6d6dc9",
  },
  '& .MuiDataGrid-columnHeader[data-field="Male"]': {
    borderLeft: "2px dotted #167bc3",
  },
  '& .MuiDataGrid-cell[data-field="Male"]': {
    borderLeft: "2px dotted #167bc3",
  },
  "& .MuiDataGrid-cell": {
    textAlign: "center",
  },
  "& .MuiDataGrid-scrollbar--horizontal": {
    display: "block",
  },
  overflowX: "auto",
  overflowY: "auto",
  width: "100%",
  height: "100%",
}));

const PLACEHOLDER_COLUMNS = [
  "species",
  "Male",
  "Female",
  "Sex unknown",
  "Total_Count",
];

export default function AbundanceDataPreview({ data, loading, dataGridRef }) {
  const columns = useMemo(() => {
    const orderedColumns =
      data && data.length > 0
        ? reorderColumnsWithFixedEnd(data, {
            fixedStart: "species",
            fixedEnd: ["Male", "Female", "Sex unknown", "Total_Count"],
          }).columnOrder
        : PLACEHOLDER_COLUMNS;

    // Map to column definitions for DataGrid
    return orderedColumns.map((key) => ({
      field: key,
      headerName:
        key === "Male" ? "Total_Male" : key === "Female" ? "Total_Female" : key,
      minWidth: 200,
      headerAlign: "center",
    }));
  }, [data]);

  const rows = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }
    const lastRow = data[data.length - 1];
    const parsedData = data.slice(0, -1);

    parsedData.sort((a, b) =>
      (a.species || "").localeCompare(b.species || "", undefined, {
        sensitivity: "base",
      })
    );

    const rowsWithId = parsedData.map((row, index) => ({
      ...row,
      id: index + 1,
    }));

    if (lastRow) {
      rowsWithId.unshift({
        ...lastRow,
        id: 0,
      });
    }
    return rowsWithId;
  }, [data]);

  return (
    <div
      style={{
        paddingTop: "1rem",
        paddingBottom: "1rem",
        fontSize: "11px",
        width: "100%",
        height: "100%",
      }}
    >
      <Container
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <StyledDataGrid
          apiRef={dataGridRef}
          rows={rows}
          columns={columns}
          loading={loading}
          localeText={{ noRowsLabel: "No Data" }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 20,
              },
            },
            columns: {
              columnVisibilityModel: {
                empty: false,
                Unsure: false,
                // 'Male': false,
                // 'Female': false,
                // 'Sex unknown': false,
              },
            },
          }}
          slots={{
            toolbar: CustomToolbar,
            pagination: CustomPagination,
          }}
          showToolbar
          disableDensitySelector={true}
          pageSizeOptions={[10, 20, 50]}
        />
      </Container>
    </div>
  );
}
